module.exports = __webpack_public_path__ + "img/img_nat_banner.8de7c342.png";